// extracted by mini-css-extract-plugin
module.exports = {"player":"videoModal_player__MM75E"};